// Plain-English review reasons. Mirrors backend services/review_reason_text.py
// so legacy rows (already stored with machine wording) read cleanly too.
const DOC_LABELS = {
  software_subscription: 'Software subscription',
  bill: 'Bill / supplier payment',
  bill_payment: 'Bill / supplier payment',
  invoice: 'Customer invoice',
  other_payment: '',
  other_receipt: '',
  expense_direct: '',
  bank_charges: 'Bank charge',
  salary_payment: 'Salary payment',
  payroll: 'Payroll',
  loan: 'Loan',
  loan_received: 'Loan received',
  loan_repayment: 'Loan repayment',
  capital_contribution: "Owner's capital",
  internal_transfer: 'Transfer between your accounts',
  prepayment: 'Prepayment',
  fixed_asset: 'Fixed asset',
  investment: 'Investment',
  deferred_revenue: 'Deferred revenue',
  parking_tolls: 'Parking & tolls',
  customer_payment: 'Customer payment',
  general: '',
};

export const pct = (c) => {
  let n = Number(c || 0);
  if (Number.isNaN(n)) return '0%';
  if (n <= 1) n *= 100;
  return `${Math.round(n)}%`;
};

const times = (n) => (n <= 0 ? 'not before' : n === 1 ? 'once before' : n === 2 ? 'twice before' : `${n} times before`);
const confPhrase = (raw) => (raw ? ` (${pct(parseFloat(raw))} confidence)` : '');
const label = (t) => {
  const k = (t || '').toLowerCase();
  if (k in DOC_LABELS) return DOC_LABELS[k];
  return k ? k.replace(/_/g, ' ').replace(/^./, (ch) => ch.toUpperCase()) : '';
};

export function humanizeReviewReason(text) {
  if (!text || typeof text !== 'string') return text;
  let out = text.trim();
  out = out.replace(/\s*\|\s*iter\d+[^|]*/g, '');
  out = out.replace(/^Retro-classified via [a-z_]+:\s*/i, '');

  let prefix = '';
  const ai = out.match(/^\s*AI:\s*([a-z_]+)\s*\/\s*([a-z_]+)\s*-\s*/i);
  if (ai) {
    const l = label(ai[2]) || label(ai[1]);
    prefix = l ? `Suggested as ${l}. ` : '';
    out = out.slice(ai[0].length);
  }

  out = out.replace(
    /Cached from prior classification \(description ~ '([^']*?)…?',?\s*(?:seen (\d+)×)?\s*(?:→\s*conf\s*([\d.]+))?\)/g,
    (_, d, seen, conf) =>
      `Looks like '${d}', which we've categorised ${seen ? times(parseInt(seen, 10)) : 'before'}${confPhrase(conf)}. It needs one more sighting or your approval before it posts automatically.`,
  );
  out = out.replace(
    /Repeat of a transaction you previously confirmed \(description ~ '([^']*?)…?',?\s*(?:conf\s*([\d.]+))?\)/g,
    (_, d, conf) => `Looks like '${d}', which you confirmed before${confPhrase(conf)}.`,
  );
  out = out.replace(/Matched learned rule \[[^\]]*\]/g, 'Matches a rule learned from your earlier approvals.');
  out = out.replace(
    /Company KB: '([^']*)' → (.+?) \((\d+)\), conf=([\d.]+)/g,
    (_, name, gl, __, conf) => `'${name}' is a known merchant, usually booked to ${gl} (${pct(parseFloat(conf))} confidence).`,
  );
  out = out.replace(
    /Needs your confirmation: automatic confidence (\d+)% is below the posting threshold\.?/g,
    (_, c) => `Confidence is ${c}%, below the 80% needed to post automatically. Please confirm the category.`,
  );
  out = out.replace(
    /AI confidence (\d+)% is below your auto-post threshold \((\d+)%\)\.?/g,
    (_, c, t) => `Confidence is ${c}%, below your ${t}% auto-post level. Please confirm the category.`,
  );
  out = out.replace(/conf(?:idence)?\s*[=:→]?\s*0?\.(\d{1,3})\b/gi, (_, d) => `${pct(parseFloat(`0.${d}`))} confidence`);
  out = out.replace(/(?<![\d.$£€₦])\b0\.(\d{2})\b(?![\d.%])/g, (_, d) => pct(parseFloat(`0.${d}`)));
  out = out.replace(/\s{2,}/g, ' ').trim();
  return (prefix + out).trim() || text;
}
